 <!-- LEGENDA -->
 <div id="legenda-rv" class="legenda">  
    <h2 style="float: left; margin-right: 20px;">LEGENDA</h2>
    <div style="margin-top: 10px;">        
        <div 
            class="card-estrategia" 
            *ngFor="let estrategia of listEstrategia"
        >
            <div
                class="card-estrategia-cor"
                style="width: 30px; height: 30px;"
                [ngClass]="estrategia.cor_hexadecimal"
            >
            </div> 
            <span class="card-estrategia-texto">
                {{ estrategia.nome }}
            </span>
        </div>
    </div>
</div>